import { render, staticRenderFns } from "./PollManagement.vue?vue&type=template&id=51c834a7&scoped=true&"
import script from "./PollManagement.vue?vue&type=script&lang=js&"
export * from "./PollManagement.vue?vue&type=script&lang=js&"
import style0 from "./PollManagement.vue?vue&type=style&index=0&id=51c834a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c834a7",
  null
  
)

export default component.exports